import React from 'react';
import { NotificationPanel } from '@repo/ui';
import twinlabsAiStackedLogo from '@repo/assets/logos/twinlabs-ai-stacked-logo.svg';

interface Props {}

const SomethingWentWrongPage: React.FC<Props> = () => {
  return (
    <>
      <NotificationPanel
        imgSrc={twinlabsAiStackedLogo}
        imgAlt="Twinlabs.ai Logo"
        header="Oops! Something Went Wrong"
        copy="Please try again."
        backRoute="/"
      />
    </>
  );
};

export default SomethingWentWrongPage;
